import { render, staticRenderFns } from "./adminShare.vue?vue&type=template&id=20cd1b4e&"
import script from "./adminShare.vue?vue&type=script&lang=js&"
export * from "./adminShare.vue?vue&type=script&lang=js&"
import style0 from "./adminShare.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports